<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :text="text">         
                    <v-form ref="form">
                        <v-container py-0>
                            <v-layout wrap>
                                 
                                <v-flex xs12 md12>
                                    <date-picker v-model="dataSelecionada" :required="true" :requiredText="selecionePeriodo" :label="periodo">
                                    </date-picker>
                                </v-flex>  
                                
                                <v-flex xs12 md12>
                                    <v-alert icon="mdi-shield-lock-outline" prominent text type="info">
                                            Não criar um novo calendário quando o processo do QlikView (CuboQV/Extrator Dos Lançamentos SAP) estiver em Processamento
                                    </v-alert>
                                </v-flex>  
                                
                                <v-flex class="d-flex justify-center">
                                    <v-btn color="red" @click="historyBack" label="Salvar">
                                        <v-icon left>mdi-arrow-left</v-icon> 
                                        {{textBack}}
                                    </v-btn>     
                                    
                                    <v-btn color="green" @click="salvar">
                                        <v-icon left>mdi-check</v-icon> 
                                        {{textSave}}
                                    </v-btn>                 
                                </v-flex>                                
                            </v-layout>
                        </v-container>
                    </v-form>                                                    
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ApiQlick from '@/api/csc/integracoes/qlikview'
import DateMixin from '@/mixin/date'
import FormMixin from '@/mixin/form'

import DatePickerRange from '@/components/material/DatePicker'
import getters from '@/store/modules/app/getters'

export default {
    mixins: [ ApiQlick, FormMixin, DateMixin ],  
    components: {
        "date-picker": DatePickerRange
    },   
    data () {
        return { 
           textSave: "Salvar",
           textBack: "Voltar",
           date: new Date().toISOString().substr(0, 10),
           landscape: false,
           user: getters,
           month: true,      
           dataSelecionada: "",     
           calendarModel: {
               id: 0,
               mes: null,
               ano: null,
               dataCorte: null,
               usuario: null
           },
           calendarModelLog: {
               id: 0,
               login: "",
               calendarioLancamentoContabil: 0
           }            
        }
    },
    created(){      
        this.formUniqueCode = "FORM.CSC.00001";
        this.privilegeUniqueCode = "INSE";
    },
    async mounted(){       
        this.$set(this, "dataSelecionada");
    },
    computed: {  
        text () {
            return this.$t('Views.Integracoes.QlikView.Editar.form-text-add')            
        },
        selecionePeriodo(){
            return this.$t('Views.Integracoes.QlikView.Editar.selecione-periodo');            
        },
        periodo(){
            return this.$t('Views.Integracoes.QlikView.Editar.periodo');            
        },
         username(){
            return this.$store.state.app.userName;
        }                                 
    },
    methods:{    
        historyBack(){
            this.$router.go(-1);
        }, 
        async salvar(){
            var date = new Date(this.dataSelecionada);
            var mnth = ("0" + (date.getMonth() + 1)).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);
            this.dataSelecionada = [date.getFullYear(), mnth, day].join("-");
            
            this.calendarModel.ano = this.$_.parseInt(this.dataSelecionada.substr(0,4));
            this.calendarModel.mes = this.$_.parseInt(this.dataSelecionada.substr(5,2));
            this.calendarModel.dataCorte = this.dataSelecionada;
            this.calendarModel.usuario = this.$store.state.app.user.email;

            const processing = this.showProcessing();
            const resultado = await ApiQlick.inserir(this.calendarModel).catch(erro => this.showSnackbarError(erro.error));

            if(resultado.success){
                this.showMessage(
                    this.$t("Views.Integracoes.QlikView.Editar.titulo-sucesso-adicionar"), 
                    this.$t("Views.Integracoes.QlikView.Editar.mensagem-sucesso-adicionar"),
                    () => this.$router.push("/integracoes/qlikview")
                );                
            }
            else if(resultado.validationException)
                this.showError("Erro ao incluir a aplicação", resultado.error);

            processing.close();  
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>